import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Image } from '@codex/basics';
import { Close } from '@codex/organisms';
import { Device, DeviceProvider, Toggleable } from '@codex/gadgets';
import CompareProductTooltip from './CompareProductTooltip';

const CompareProductWrapper = styled.div`
  width: 100%;
`;

const ProductTitle = styled.div`
  width: auto;
  max-width: calc(100% - 75px);
  max-height: 28px;
  overflow: hidden;
  display: inline-block;
  margin-top: 5px;
  @media only screen and (max-device-width: 1024px) {
    max-height: 25px;
    font-size: 10px;
  }
`;

const StyledClose = styled(Close)`
  position: absolute;
  top: 21%;
  right: 0;
`;

const HoverBridge = styled.div`
  position: absolute;
  bottom: -30px;
  left: 110px;
  height: 30px;
  width: 100px;
`;

const ComparePanelProductTooltip = styled.div`
  z-index: 4;
  left: 50%;
  position: absolute;
  bottom: calc(100% + 30px);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
`;

const ComparePanelItemLink = styled.a`
  color: #666;
  text-decoration: none;
`;

const ComparePanelItemLinkImage = styled(Image)`
  width: auto;
  height: 35px;
  margin: 0 5px;
  display: inline;
  float: left;

  .dc-loader {
    height: 36px;
    background-color: white;
  }

  span {
    margin: 2px 0;
  }
`;

export default function CompareProduct(props) {
  const titleProduct = `${props.brand} ${props.title}`;
  return (
    <DeviceProvider>
      <Device>
        {({ isDesktop }) => (
          <Toggleable closeOnPageScroll closeOnOutsideClick>
            {({ open, toggle, innerRef }) => (
              <CompareProductWrapper
                ref={innerRef}
                {...(isDesktop ? { onMouseLeave: () => toggle(false) } : {})}
              >
                <ComparePanelItemLink
                  className={'dc-compare-panel-item-link'}
                  {...{
                    [isDesktop ? 'onMouseEnter' : 'onClick']: (event) => {
                      event.preventDefault();
                      toggle(!open);
                    }
                  }}
                >
                  <ComparePanelItemLinkImage
                    image={props.imageSrc}
                    alt={props.title ? props.title : ''}
                  />

                  <ProductTitle>{titleProduct}</ProductTitle>

                  <StyledClose onClose={props.onRemove} />
                </ComparePanelItemLink>

                {open && (
                  <ComparePanelProductTooltip className={'dc-compare-panel-product__tooltip'}>
                    <CompareProductTooltip
                      imageUrl={props.imageSrc}
                      price={props.price}
                      isProductOutOfStock={props.isProductOutOfStock}
                      title={props.title}
                      productUrl={props.url}
                      imageAlt={props.imageAlt}
                      brand={props.brand}
                      translations={props.translations}
                      firstChild={props.firstChild}
                      onProductClick={props.onTooltipClick}
                    />
                    <HoverBridge />
                  </ComparePanelProductTooltip>
                )}
              </CompareProductWrapper>
            )}
          </Toggleable>
        )}
      </Device>
    </DeviceProvider>
  );
}

CompareProduct.displayName = 'CompareProduct';

CompareProduct.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
  imageSrc: PropTypes.string.isRequired,
  brand: PropTypes.string,
  imageAlt: PropTypes.string,
  onRemove: PropTypes.func,
  price: PropTypes.shape({
    currentPrice: PropTypes.string,
    savingsPrice: PropTypes.string,
    wasPrice: PropTypes.string,
    wasPriceFrom: PropTypes.string,
    wasPriceTo: PropTypes.string
  }).isRequired,
  isProductOutOfStock: PropTypes.bool.isRequired,
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  firstChild: PropTypes.bool,
  onTooltipClick: PropTypes.func,
  isDesktop: PropTypes.bool.isRequired
};

CompareProduct.defaultProps = {
  url: '#',
  brand: '',
  imageAlt: '',
  onRemove: () => {},
  firstChild: false,
  onTooltipClick: () => {}
};
